export const setTermsForm = (termsFormOpen,submitSource,versionId) => ({
  type: 'SET_TERMS_FORM_OPEN',
  termsFormOpen,
  submitSource,
  versionId:versionId
});
export const setAlpsSelectedSubEntityId = (selectedSubEntityId) => ({
  type: 'SET_ALPS_SELECTED_SUB_ENTITY_ID',
  selectedSubEntityId,
});
export const addToPendingSubmit = (pendingSubmitValues) => ({
  type: 'ADD_TO_PENDING_SUBMIT',
  pendingSubmitValues,
});

export const clearPendingSubmit = () => ({
  type: 'CLEAR_PENDING_SUBMIT',
});

export const handlePendingSubmitAction = (values, dispatch, props, name) => ({
  type: 'PROMPT_FOR_TERMS',
  pendingSubmitValues: values,
  name,
});

export const submitTermsForm = () => ({
  type: 'TERMS_FORM_SUBMIT',
});

export const changeVersionForm = (versionId) => ({
  type: 'CHANGE_VERSION',
  entityName: 'alps',
  versionId: versionId
});

export const loadHistory = () => ({
  type: 'LOAD_HISTORY',
});
export const  submitAlpsDataForm = (values,dispatch, props) => ({
  type: 'CREATE_ENTITY_ALPS',
  entityName: 'alps',
  values: values
});
;